import { useEffect, useState } from "react";
import Card from "../../../components/ui/card-snippet";
import {
  respEnum,
} from "../../../constants/appConstant";
import Common from "../../../helper/common";
import {
  AppInput,
  AppSearchSectionSelect,
} from "../../../components/appComponents";
import Utility from "../../../helper/utilityHelper";
import { Button } from "../../../components/ui/button";
import common from "../../../helper/common";

export default function StockLogDetails() {
  const firstDayOfMonth = common.moment
    .utc()
    .startOf("month")
    .format("YYYY-MM-DD");
  const lastDayOfMonth = common.moment
    .utc()
    .endOf("month")
    .startOf("day")
    .format("YYYY-MM-DD");

  const [stockDetails, setStockDetails] = useState([]);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [tillDate, setTillDate] = useState(lastDayOfMonth);
  const [productId, setProductId] = useState([]);
  const [productList, setProductList] = useState([]);



  useEffect(() => {
    getAllProducts();
    fetchStockBalance();
  }, []);

  useEffect(() => {
    fetchStockBalance();
  }, [startDate, tillDate, productId]);

  const resetFilters = () => {
    setStartDate(firstDayOfMonth);
    setTillDate(lastDayOfMonth);
    setProductId(null);
  };

 

  const getAllProducts = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetProductsForPOS"
    );

    if (response?.status == respEnum.Success) {
       const data = [
      // { value: null, label: "All" },
      ...(response?.data ?? []).map(x => ({
          value: x.id,
          label: x.name
      }))
    ];
      setProductList(data);
    }
  };

  const fetchStockBalance = async () => {
    if (startDate && tillDate && startDate > tillDate) {
      Common.showToast("End Time must be greater", "Error", "info");
      return;
    }
    
    const params = new URLSearchParams();

    if (startDate) {
      params.append("startDateTime", startDate);
    }

    if (tillDate) {
      params.append("tillDate", tillDate);
    }

    // if (productId?.value) {
    //   params.append("productId", productId.value);
    // }
    if (productId?.length > 0) {
      // params.append(
      //   "productId",
      //   productId.map(p => p.value).join(",")
      // );
      // Instead of "1,4,3"
    productId.forEach(p => params.append("productId", p.value));

    }

    // const requestData = {
    //   startDate: startDate || null,
    //   tillDate: tillDate || null,
    //   productId:
    //     productId?.length > 0
    //       ? productId
    //           .map((x) => x.value)
    //           .filter((val) => val !== null)
    //       : null,
    //     }

    
    const response = await Common.ApiService.getInstance().request(
      `GetStockSummary?${params.toString()}`
      //  "GetStockSummary",
      //   requestData,
    );

    if (response?.status === respEnum.Success) {
      setStockDetails(response.data || []);
      
      // setStockDetails(response.data[0] || []);
      
    }
  };

  return (
    <div className="space-y-6 mb-6">
      <style>
        {`
                    .paddingleft6 {
                        padding-left: 6px!important;
                    }

                    @media screen and (max-width: 768px) {
                        .paddingleft6 {
                            padding-left: 0px !important;
                        }
                             .paddingall {
                            padding-left: 10px !important;
                            padding-right: 10px !important;
                        }
                    }
                `}
      </style>

      <Card title="Stock Report">
        <div className="grid grid-cols-1 sm:grid-cols-6 gap-4 mt-5 paddingall">
          <AppInput
            type={"date"}
            value={startDate}
            onChange={(e) => {
              const selectedstartDate = e;
              if (tillDate && selectedstartDate > tillDate) {
                Common.showToast(
                  "Start Time must be lesser than End Time",
                  "Error",
                  "info"
                );
                setStartDate(null);
              } else {
                setStartDate(selectedstartDate);
              }
            }}
            label="From"
            className="mb-3 col-span-1 paddingleft6"
          />

          <AppInput
            type={"date"}
            value={tillDate}
            onChange={(e) => {
              const selectedEndDate = e;
              if (selectedEndDate < startDate) {
                Common.showToast("End Time must be greater", "Error", "info");
                setTillDate("");
              } else {
                setTillDate(selectedEndDate);
              }
            }}
            label="Till"
            className="mb-3 col-span-1"
          />

        <AppSearchSectionSelect
            value={productId}
            onChange={setProductId}
            placeholder={"All"}
            label={"Product"}
            data={productList}
            className={"mb-3 col-span-1"}
            isMulti={true}
            />

          <Button
            className="lg:mt-6 h-8 mb-6 w-[120px] px-2 col-span-1"
            onClick={resetFilters}
          >
            Reset Filter
          </Button>
        </div>
      </Card>

      {/* Results Table */}

      {/* {(!stockDetails || Object.keys(stockDetails).length > 0) && (
        <Card title="">
          <table className="min-w-full divide-y divide-gray-200 border">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="row"
                  colSpan={3}
                  className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider"
                >
                  Stock Details
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 font-bold">
              {Object.entries(stockDetails).map(([key, value]) => {
                const keyMapping = {
                  stockIn: "Stock_In",
                  stockOut: "Stock_Out",
                  productName: "productName",

                };

                const displayKey = keyMapping[key] || key.replace(/_/g, " ");

                return (
                  <tr key={key}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
                      {displayKey}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                      <div className="flex items-center gap-2 relative overflow-visible">
                        <span className="text-sm md:text-base font-medium">
                          {Utility.formatNumberWithCommas(Math.abs(value))}
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      )} */}
{/* Results Table */}
{Array.isArray(stockDetails) && stockDetails.length > 0 && (
  <Card >
    <table className="min-w-full divide-y divide-gray-200 border">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider">
            Product Name
          </th>
          <th className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider">
            Category Name
          </th>
          <th className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider">
            Stock In
          </th>
          <th className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider">
            Stock Out
          </th>
           {/* <th className="px-6 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider">
            Current Stock
          </th> */}
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200 font-bold">
        {stockDetails.map((item, index) => (
          <tr key={index}>


            {/* Product Name */}
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
              {item.productName ?? "-"}
            </td>
            
            {/*Category Name */}
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
            {item.categoryName ?? "-"}
            </td>

            {/* Stock In */}
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
              {Utility.formatNumberWithCommas(item.Stock_In ?? 0)}
            </td>

            {/* Stock Out */}
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
              {Utility.formatNumberWithCommas(Math.abs(item.Stock_Out ?? 0))}
            </td>

            {/* Stock Balance */}
            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
              {Utility.formatNumberWithCommas(Math.abs(item.currentStock ?? 0))}
            </td> */}
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
)}

    </div>
  );
}
